import React, { Component } from "react";
import { ConstantBasedPicker } from "@openimis/fe-core";

import { SUPPORTINGPERSON } from "../constants";

class SupportingPersonPicker extends Component {

    render() {
        const { readOnly = false, required = false, withNull = true, nullLabel = null } = this.props;
        
        return <ConstantBasedPicker
            module="niue"
            constants={SUPPORTINGPERSON}
            readOnly={readOnly}
            {...this.props}
        />
    }
}

export default SupportingPersonPicker;